import { render, staticRenderFns } from "./WechartApplet.vue?vue&type=template&id=9d1caabe&scoped=true&"
import script from "./WechartApplet.vue?vue&type=script&lang=js&"
export * from "./WechartApplet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1caabe",
  null
  
)

export default component.exports